import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const Container = styled("div")`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export function NoRowsOverlay() {
  const { t } = useTranslation();
  return (
    <Container>
      <Typography>{t("logbook.noTripsFound")}</Typography>
    </Container>
  );
}
